/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {InputToggleTextModel} from '../../shared/components/bundling-settings-inputs/input-toggle-text/models/input-toggle-text.model';
import {InputToggleDropdownModel} from '../../shared/components/bundling-settings-inputs/input-toggle-dropdown/models/input-toggle-dropdown.model';
import {BundlingSettingsEditedFormDataModel} from '../models/bundling-settings-edited-form-data.model';
import {
    BundlingSettingsDetailModel
} from '../../bundles-main-page/models/bundling-settings-detail/bundling-settings-detail.model';
import {BundlingSettingsContract} from '../../api/contracts/bundle-settings/bundling-settings.contract';

export class BundlingSettingsMapper {

    static fromFormDataValueToInputToggleTextModel(data: number, isEditMode: boolean, toggleActive: boolean, toggleDisable: boolean):
            InputToggleTextModel {
        return {
            viewMode: !isEditMode,
            value: (data != null && !toggleDisable) ? data : '',
            toggleActive,
            toggleDisable
        };
    }

    static fromFormDataValueToInputToggleDropdownModel(data: string, isEditMode: boolean, toggleActive: boolean, toggleDisable: boolean):
            InputToggleDropdownModel {
        return {
            viewMode: !isEditMode,
            value: (data != null && !toggleDisable) ? data : null,
            toggleActive,
            toggleDisable,
        };
    }

    static fromBundlingSettingsDetailModelToBundlingSettingsEditedFormDataModel(data: BundlingSettingsDetailModel,
                                                                                currencyCode: string):
            BundlingSettingsEditedFormDataModel {
        if (data != null) {
            return {
                active: data.active,
                currencyCode: currencyCode,
                periodicity: {
                    value: data.periodicity?.code,
                    isValid: true
                },
                periodDaysOffset: {
                    value: data.periodDaysOffset?.toString(),
                    isValid: true
                },
                periodMaxBundles: {
                    value: data.periodMaxBundles?.toString(),
                    isValid: true
                },
                bundleMaxPositions: {
                    value: data.bundleMaxPositions?.toString(),
                    isValid: true
                },
                bundleMaxValue: {
                    value: data.bundleMaxValue?.toString(),
                    isValid: true
                },
                bundleCriterionSpec: {
                    value: data.bundleCriterion?.code,
                    isValid: true
                },
                bundlePositionCriterionSpec: {
                    value: data.bundlePositionCriterion?.code,
                    isValid: true
                }
            };
        } else {
            return {
                active: false
            };
        }
    }

    static fromBundlingSettingsEditedFormDataModelToBundlingSettingsContract(data: BundlingSettingsEditedFormDataModel):
            BundlingSettingsContract {
        if (data != null) {
            const value = data.bundlePositionCriterionSpec.value == null ? undefined : data.bundleMaxPositions.value;
            return {
                currencyCode: data.currencyCode,
                periodicityCode: data.periodicity?.value,
                periodDaysOffset: Number(data.periodDaysOffset.value),
                periodMaxBundles: Number(data.periodMaxBundles.value),
                bundleMaxPositions: Number(value),
                bundleMaxValue: Number(data.bundleMaxValue?.value),
                bundleCriterionSpecCode: data.bundleCriterionSpec?.value,
                bundlePositionCriterionSpecCode: data.bundlePositionCriterionSpec?.value,
            };
        }
    }
}
